/**
 * Portal Manta · agNarrativaAI
 * Extraído de App.jsx v29.3 (via AST)
 */
import React, { useState, useEffect, useMemo, useCallback, Fragment, memo } from 'react';
import { sumBy } from '../../globals.js';
import { API } from '../../app-globals.js';

async function agNarrativaAI(ctx, prev){
  if(!API.enabled) return {status:'pulado', msg:'backend OFF'};
  const {lote, sig, ext, od} = ctx;
  const conc = prev?.conclusao || {};
  try {
    const out = await API.post('/api/agentes/orcamentista', {inputs:{
      ext_km:ext,
      pct_dup:((sumBy(od.duplicacoes||[],'km')+sumBy(od.contornos||[],'km'))/ext*100),
      oae_qty:sumBy(od.oaes||[],'n'),
      inter_qty:sumBy(od.diamantes||[],'n')+sumBy(od.trombetas||[],'n')+sumBy(od.parclos||[],'n')+sumBy(od.rotatorias||[],'n'),
      contexto: (conc.qualitativa?.contexto||'').startsWith('Periurbano')?'periurbano':'rural'
    }});
    return {status:'ok', narrativa: out?.orcamento?.narrativa, raw: out};
  } catch(e){
    return {status:'erro', erro: e.message};
  }
}

export { agNarrativaAI };
export default agNarrativaAI;
